import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Select from "react-select";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./reset.css";

import { errorHandler } from "../../utils/helpers/errorHandler";

import { uploadDataset } from "../../utils/api/dataset";
import { addDataset } from "../../store/actions/actions/dataset";

import { storeMetrics } from "../../store/actions/actions/metrics";

import { addInteractiveAnalysis } from "../../store/actions/actions/interactiveAnalysis";
import { uploadInteractiveAnalysis } from "../../utils/api/interactiveAnalysis";

import { uploadPublication } from "../../utils/api/publication";
import { createTeamMember } from "../../utils/api/team";
import { addPublication } from "../../store/actions/actions/publication";
import { addTeamMember } from "../../store/actions/actions/team";

import { uploadQuestionLogic } from "../../utils/api/questionLogic";
import { addQuestion } from "../../store/actions/actions/question";

import { uploadSliceAndDice } from "../../utils/api/sliceAndDice";

import { createSection, fetchAllSections } from "../../utils/api/cms/section";
import { createPage } from "../../utils/api/cms/page";
import { addPage } from "../../store/actions/actions/cms/pages";
import { addSection } from "../../store/actions/actions/cms/sections";
import Chip from "./chip";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const Upload = () => {
  const dispatch = useDispatch();

  const token = JSON.parse(localStorage.getItem("eko-360-p2-token")),
    metrics = useSelector((state) => state.metrics.metrics);

  const [descriptionValue, setDescriptionValue] = useState(""),
    [datasetName, setDatasetName] = useState(""),
    [file, setFile] = useState(null),
    [showLoader, setShowLoader] = useState(false),
    [datasetCategory, setDatasetCategory] = useState(""),
    [showInteractiveAnalysisLoader, setShowInteractiveAnalysisLoader] =
      useState(false),
    [showPublicationLoader, setShowPublicationLoader] = useState(false),
    [showTeamLoader, setShowTeamLoader] = useState(false);

  const [datasetType, setDatasetType] = useState("file"),
    [title, setTitle] = useState(""),
    [consent, setConsent] = useState(false),
    [email, setEmail] = useState("");

  const [interactiveAnalysisTitle, setInteractiveAnalysisTitle] = useState(""),
    [interactiveAnalysisDescription, setInteractiveAnalysisDescription] =
      useState(""),
    [interactiveAnalysisType, setInteractiveAnalysisType] = useState("image"),
    [interactiveAnalysisFile, setInteractiveAnalysisFile] = useState(undefined),
    [interactiveCategory, setInteractivityCategory] = useState("");

  const [publicationTitle, setPublicationTitle] = useState(""),
    [publicationBody, setPublicationBody] = useState(""),
    [publicationIframe, setPublicationIframe] = useState(""),
    [publicationBanner, setPublicationBanner] = useState(undefined),
    [publicationFile, setPublicationFile] = useState(undefined);

  const [teamName, setTeamName] = useState(""),
    [teamPosition, setTeamPosition] = useState(""),
    [teamOffice, setTeamOffice] = useState(""),
    [teamImage, setTeamImage] = useState(undefined);

  const [keyword, setKeyword] = useState([]),
    [question, setQuestion] = useState(""),
    [questionDescription, setQuestionDestription] = useState(""),
    [questionFinding, setQuestionFinding] = useState(""),
    [questionType, setQuestionType] = useState("file"),
    [analytics, setAnalytics] = useState(""),
    [showQuestionLoader, setShowQuestionLoader] = useState(false);

  const [sectionName, setSectionName] = useState(""),
    [sectionBody, setSectionBody] = useState(undefined),
    [sectionPosition, setSectionPosition] = useState("right"),
    [sectionType, setSectionType] = useState("image"),
    [showSectionLoader, setShowSectionLoader] = useState(false);

  const [sectionOptions, setSectionOptions] = useState([]),
    [pageTitle, setPageTitle] = useState(""),
    [pageBody, setPageBody] = useState(""),
    [pageBanner, setPageBanner] = useState(undefined),
    [pageSections, setPageSections] = useState(""),
    [showPageLoader, setShowPageLoader] = useState(false),
    [pageType, setPageType] = useState("pages"),
    [datasetFile, setDatasetFile] = useState(undefined),
    [iFrame, setPageIframe] = useState(undefined);

  const [budgets, setBudget] = useState("");

  const [sliceAndDiceFile, setSliceAndDiceFile] = useState(undefined),
    [showSliceAndDiceLoader, setShowSliceAndDiceLoader] = useState(false);

  // Validation states
  const [descriptionError, setDescriptionError] = useState("");
  const [questionDescriptionError, setQuestionDescriptionError] = useState("");
  const [interactiveDescriptionError, setInteractiveDescriptionError] = useState("");
  const [publicationBodyError, setPublicationBodyError] = useState("");
  const [sectionBodyError, setSectionBodyError] = useState("");
  
  // Title validation states
  const [datasetNameError, setDatasetNameError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [interactiveTitleError, setInteractiveTitleError] = useState("");
  const [publicationTitleError, setPublicationTitleError] = useState("");
  const [teamNameError, setTeamNameError] = useState("");
  const [questionError, setQuestionError] = useState("");
  const [sectionNameError, setSectionNameError] = useState("");
  const [pageTitleError, setPageTitleError] = useState("");

  // Validation configuration
  const MIN_DESCRIPTION_LENGTH = 10;
  const MIN_TITLE_LENGTH = 3;

  // Validation functions
  const validateDescription = (text) => {
    if (text.length > 0 && text.length < MIN_DESCRIPTION_LENGTH) {
      return "Description must be at least 10 characters";
    }
    return "";
  };

  const validateTitle = (text) => {
    if (text.length > 0 && text.length < MIN_TITLE_LENGTH) {
      return "Title must be at least 3 characters";
    }
    return "";
  };

  // Handler for dataset description
  const handleDescriptionChange = (value) => {
    setDescriptionValue(value);
    const error = validateDescription(value);
    setDescriptionError(error);
  };

  // Handler for question description
  const handleQuestionDescriptionChange = (value) => {
    setQuestionDestription(value);
    const error = validateDescription(value);
    setQuestionDescriptionError(error);
  };

  // Handler for interactive analysis description
  const handleInteractiveDescriptionChange = (value) => {
    setInteractiveAnalysisDescription(value);
    const error = validateDescription(value);
    setInteractiveDescriptionError(error);
  };

  // Handler for publication body
  const handlePublicationBodyChange = (value) => {
    setPublicationBody(value);
    const error = validateDescription(value);
    setPublicationBodyError(error);
  };

  // Handler for section body (when type is content)
  const handleSectionBodyChange = (value) => {
    setSectionBody(value);
    if (sectionType === "content") {
      const error = validateDescription(value);
      setSectionBodyError(error);
    } else {
      setSectionBodyError("");
    }
  };

  // Title handlers
  const handleDatasetNameChange = (value) => {
    setDatasetName(value);
    const error = validateTitle(value);
    setDatasetNameError(error);
  };

  const handleTitleChange = (value) => {
    setTitle(value);
    const error = validateTitle(value);
    setTitleError(error);
  };

  const handleInteractiveTitleChange = (value) => {
    setInteractiveAnalysisTitle(value);
    const error = validateTitle(value);
    setInteractiveTitleError(error);
  };

  const handlePublicationTitleChange = (value) => {
    setPublicationTitle(value);
    const error = validateTitle(value);
    setPublicationTitleError(error);
  };

  const handleTeamNameChange = (value) => {
    setTeamName(value);
    const error = validateTitle(value);
    setTeamNameError(error);
  };

  const handleQuestionChange = (value) => {
    setQuestion(value);
    const error = validateTitle(value);
    setQuestionError(error);
  };

  const handleSectionNameChange = (value) => {
    setSectionName(value);
    const error = validateTitle(value);
    setSectionNameError(error);
  };

  const handlePageTitleChange = (value) => {
    setPageTitle(value);
    const error = validateTitle(value);
    setPageTitleError(error);
  };

  // Updated submit handlers with validation and auto-close
  const handleSubmitDataset = async () => {
    const datasetNameValidation = validateTitle(datasetName);
    const descriptionValidation = validateDescription(descriptionValue);
    const titleValidation = validateTitle(title);

    if (datasetNameValidation) {
      setDatasetNameError(datasetNameValidation);
      toast.error(datasetNameValidation);
      return;
    }
    if (descriptionValidation) {
      setDescriptionError(descriptionValidation);
      toast.error(descriptionValidation);
      return;
    }
    if (titleValidation) {
      setTitleError(titleValidation);
      toast.error(titleValidation);
      return;
    }

    setShowLoader(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", datasetName);
      formData.append("description", descriptionValue);
      formData.append("title", title);
      formData.append("email", email);
      formData.append("consent", consent);
      formData.append("type", datasetType);
      formData.append("category", datasetCategory);
      formData.append(
        "fullName",
        JSON.parse(localStorage.getItem("eko-360-p2-user")).name
      );

      const dataset = await uploadDataset(formData, token);

      dispatch(addDataset(dataset.data));
      dispatch(
        storeMetrics({ ...metrics, datasetCount: metrics.datasetCount + 1 })
      );
      resetDatasetForm();
      resetModalForm();
      setShowLoader(false);
      
      // Close modal automatically on success
      const modal = document.getElementById('modal-id');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${dataset.message}`);
    } catch (error) {
      setShowLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleSubmitQuestion = async (event) => {
    event.preventDefault();
    
    const questionValidation = validateTitle(question);
    const descriptionValidation = validateDescription(questionDescription);

    if (questionValidation) {
      setQuestionError(questionValidation);
      toast.error(questionValidation);
      return;
    }
    if (descriptionValidation) {
      setQuestionDescriptionError(descriptionValidation);
      toast.error(descriptionValidation);
      return;
    }

    setShowQuestionLoader(true);
    try {
      const formData = new FormData();

      formData.append("question", question);
      formData.append("description", questionDescription);
      formData.append("keywords", keyword.join(","));
      formData.append("analytics", analytics);
      formData.append("findings", questionFinding);
      formData.append("type", questionType);

      const data = await uploadQuestionLogic(formData, token);
      
      dispatch(addQuestion(data.data));
      resetQuestionForm();
      setShowQuestionLoader(false);
      
      // Close modal automatically on success
      const modal = document.getElementById('modal-quesId');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      setTimeout(() => {
        toast.success(`${data.message}`);
      }, 300);
    } catch (error) {
      setShowQuestionLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleSubmitInteractivity = async (event) => {
    event.preventDefault();
    
    const titleValidation = validateTitle(interactiveAnalysisTitle);
    const descriptionValidation = validateDescription(interactiveAnalysisDescription);

    if (titleValidation) {
      setInteractiveTitleError(titleValidation);
      toast.error(titleValidation);
      return;
    }
    if (descriptionValidation) {
      setInteractiveDescriptionError(descriptionValidation);
      toast.error(descriptionValidation);
      return;
    }

    setShowInteractiveAnalysisLoader(true);
    try {
      if (!interactiveAnalysisFile?.length)
        throw new Error("Please attach corrensponding file");

      const formData = new FormData();
      formData.append("title", interactiveAnalysisTitle);
      formData.append("description", interactiveAnalysisDescription);
      formData.append("type", interactiveAnalysisType);
      formData.append("category", interactiveCategory);

      if (interactiveAnalysisType === "image") {
        const multipleFiles = Array.from(interactiveAnalysisFile);
        multipleFiles.forEach((file) => {
          formData.append("files", file);
        });
      } else if (interactiveAnalysisType === "iframe") {
        formData.append("url", interactiveAnalysisFile);
      } else {
        formData.append("files", interactiveAnalysisFile[0]);
      }

      const interactiveAnalysis = await uploadInteractiveAnalysis(
        formData,
        token
      );

      dispatch(addInteractiveAnalysis(interactiveAnalysis.data));
      dispatch(
        storeMetrics({
          ...metrics,
          interactivityCount: metrics.interactivityCount + 1,
        })
      );
      
      resetInteractiveAnalysisForm();
      setShowInteractiveAnalysisLoader(false);
      
      // Close modal automatically on success
      const modal = document.getElementById('modal-idia');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${interactiveAnalysis.message}`);
    } catch (error) {
      setShowInteractiveAnalysisLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleSubmitPublication = async (event) => {
    event.preventDefault();
    
    const titleValidation = validateTitle(publicationTitle);
    const bodyValidation = validateDescription(publicationBody);

    if (titleValidation) {
      setPublicationTitleError(titleValidation);
      toast.error(titleValidation);
      return;
    }
    if (bodyValidation) {
      setPublicationBodyError(bodyValidation);
      toast.error(bodyValidation);
      return;
    }

    setShowPublicationLoader(true);
    try {
      const formData = new FormData();
      formData.append("title", publicationTitle);
      formData.append("body", publicationBody);
      formData.append("banner", publicationBanner);
      formData.append("file", publicationFile);

      if (publicationIframe.trim().length > 0) {
        formData.append("iframe", publicationIframe);
      }

      const publication = await uploadPublication(formData, token);

      setShowPublicationLoader(false);
      resetPublicationForm();
      dispatch(addPublication(publication.data));

      // Close modal automatically on success
      const modal = document.getElementById('modal-idpub');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${publication.message}`);
    } catch (error) {
      setShowPublicationLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleSubmitTeam = async (event) => {
    event.preventDefault();
    
    const nameValidation = validateTitle(teamName);

    if (nameValidation) {
      setTeamNameError(nameValidation);
      toast.error(nameValidation);
      return;
    }

    setShowTeamLoader(true);
    try {
      const formData = new FormData();
      formData.append("name", teamName);
      formData.append("position", teamPosition);
      formData.append("office", teamOffice);
      formData.append("image", teamImage);

      const team = await createTeamMember(formData, token);

      setShowTeamLoader(false);
      resetTeamForm();
      dispatch(addTeamMember(team.data));

      // Close modal automatically on success
      const modal = document.getElementById('modal-team');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${team.message}`);
    } catch (error) {
      setShowTeamLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleCreateSection = async () => {
    const nameValidation = validateTitle(sectionName);
    if (nameValidation) {
      setSectionNameError(nameValidation);
      toast.error(nameValidation);
      return;
    }

    if (sectionType === "content") {
      const bodyValidation = validateDescription(sectionBody);
      if (bodyValidation) {
        setSectionBodyError(bodyValidation);
        toast.error(bodyValidation);
        return;
      }
    }

    setShowSectionLoader(true);
    try {
      const formData = new FormData();

      formData.append("name", sectionName);
      formData.append("position", sectionPosition);
      formData.append("body", sectionBody);
      formData.append("type", sectionType);

      const data = await createSection(formData, token);

      dispatch(addSection(data.data));
      resetSectionForm();
      setShowSectionLoader(false);
      
      // Close modal automatically on success
      const modal = document.getElementById('modal-section');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${data.message}`);
    } catch (error) {
      setShowSectionLoader(false);
      errorHandler(error, toast);
    }
  };

  const handleCreatePage = async () => {
    const titleValidation = validateTitle(pageTitle);
    if (titleValidation) {
      setPageTitleError(titleValidation);
      toast.error(titleValidation);
      return;
    }

    setShowPageLoader(true);
    try {
      let sectionValues = "";
      if (pageSections.length > 0) {
        sectionValues = pageSections.map((section) => section.value).join(",");
      }

      const formData = new FormData();

      if (pageType === "datasets" && datasetFile) {
        formData.append("file", datasetFile);
      }

      if (pageType === "analysis") {
        formData.append("iFrame", iFrame);
      }

      if (datasetFile) {
        formData.append("budget", budgets);
      }

      formData.append("type", pageType);
      formData.append("title", pageTitle);
      formData.append("body", pageBody);
      formData.append("banner", pageBanner);
      formData.append("sections", sectionValues);

      const data = await createPage(formData, token);

      dispatch(addPage(data.data));
      resetPageModal();
      setShowPageLoader(false);
      
      // Close modal automatically on success
      const modal = document.getElementById('modal-page');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${data.message}`);
    } catch (error) {
      errorHandler(error, toast);
      setShowPageLoader(false);
    }
  };

  const handleSubmitSliceAndDice = async () => {
    setShowSliceAndDiceLoader(true);
    try {
      if (!sliceAndDiceFile)
        throw { message: "Please attach a corresponding file" };
      const formData = new FormData();
      formData.append("file", sliceAndDiceFile);

      const data = await uploadSliceAndDice(formData, token);

      // Close modal automatically on success
      const modal = document.getElementById('modal-sliceAndDice');
      if (modal) {
        window.$(modal).modal('hide');
      }
      
      toast.success(`${data.message}`);
    } catch (error) {
      errorHandler(error, toast);
    } finally {
      setShowSliceAndDiceLoader(false);
    }
  };

  const handleCloseSliceAndDice = () => {
    const modal = document.getElementById('modal-sliceAndDice');
    if (modal) {
      window.$(modal).modal('hide');
    }
  };

  useEffect(() => {
    window.$(function () {
      window.$(".showButton").click(function () {
        window.$(".hidden1").show();
        window.$(".show1").hide();
        window.$(".__hidden2").hide();
      });

      window.$(".hideButton").click(function () {
        window.$(".hidden1").hide();
        window.$(".hidden2").hide();
        window.$(".show1").show();
        window.$(".__hidden2").show();
      });

      window.$(".showButton1").click(function () {
        window.$(".hidden2").show();
        window.$(".show2").show();
        window.$(".hidden1").hide();
        window.$(".__hidden2").hide();
      });

      window.$(".hideButton1").click(function () {
        window.$(".__hidden2").hide();
        window.$(".hidden2").hide();
        window.$(".show2").show();
        window.$(".hidden1").show();
      });

      window.$(".showButton2").click(function () {
        window.$(".__hidden2").hide();
        window.$(".hidden1").hide();
        window.$(".hidden2").hide();
        window.$(".show4").show();
      });
    });
  }, []);

  useEffect(() => {
    window.$(".js-select2").select2({
      closeOnSelect: true,
      placeholder: "Select Sections",
      templateSelection: iformat,
      templateResult: iformat,
      allowHtml: true,
      allowClear: true,
      width: "100%",
    });

    function iformat(icon, badge) {
      var originalOption = icon.element;
      var originalOptionBadge = window.$(originalOption).data("badge");

      return window.$(
        '<span><i className="fa ' +
          window.$(originalOption).data("icon") +
          '"></i> ' +
          icon.text +
          '<span className="badge">' +
          originalOptionBadge +
          "</span></span>"
      );
    }
  }, []);

  const handleFetchAllSections = async () => {
    try {
      const data = await fetchAllSections();

      const options = data.allSections.map((section) => ({
        value: section.id,
        label: section.name,
      }));

      setSectionOptions(options);
    } catch (error) {
      errorHandler(error, toast);
    }
  };

  useEffect(() => {
    handleFetchAllSections();
  }, []);

  const resetQuestionForm = () => {
    setKeyword([]);
    setQuestion("");
    setQuestionDestription("");
    setQuestionFinding("");
    setQuestionType("file");
    setAnalytics("");
    setShowQuestionLoader(false);
    setQuestionDescriptionError("");
    setQuestionError("");
  };

  const resetModalForm = () => {
    setTimeout(() => {
      window.$(".hidden1").hide();
      window.$(".__hidden2").show();
      window.$(".show1").show();
      window.$(".hidden2").hide();
      window.$(".show4").show();
    }, 300);
  };

  const resetPageModal = () => {
    setPageTitle("");
    setPageBody("");
    setPageBanner(undefined);
    setPageSections("");
    setPageIframe(undefined);
    setPageTitleError("");
  };

  const resetDatasetForm = () => {
    setFile(null);
    setDatasetName("");
    setDescriptionValue("");
    setTitle("");
    setEmail("");
    setConsent(false);
    setDatasetType("file");
    setDescriptionError("");
    setDatasetNameError("");
    setTitleError("");
  };

  const resetPublicationForm = () => {
    setPublicationTitle("");
    setPublicationBody("");
    setPublicationIframe("");
    setPublicationBanner(undefined);
    setPublicationFile(undefined);
    setPublicationBodyError("");
    setPublicationTitleError("");
  };

  const resetTeamForm = () => {
    setTeamName("");
    setTeamPosition("");
    setTeamOffice("");
    setTeamImage(undefined);
    setTeamNameError("");
  };

  const resetInteractiveAnalysisForm = () => {
    setInteractiveAnalysisFile(undefined);
    setInteractiveAnalysisType("image");
    setInteractiveAnalysisDescription("");
    setInteractiveAnalysisTitle("");
    setInteractiveDescriptionError("");
    setInteractiveTitleError("");
  };

  const resetSectionForm = () => {
    setSectionPosition("");
    setSectionType("image");
    setSectionBody("");
    setSectionName("");
    setSectionBodyError("");
    setSectionNameError("");
  };

  // File type to icon mapping
  const getFileIcon = (file) => {
    if (!file) return '📁';
    
    const extension = file.name.split('.').pop().toLowerCase();
    
    const iconMap = {
      // Images
      jpg: '🖼️', jpeg: '🖼️', png: '🖼️', gif: '🖼️', svg: '🖼️', webp: '🖼️',
      // Documents
      pdf: '📄', doc: '📝', docx: '📝', txt: '📝', 
      // Spreadsheets
      xls: '📊', xlsx: '📊', csv: '📊',
      // Videos
      mp4: '🎬', mov: '🎬', avi: '🎬', mkv: '🎬',
      // Archives
      zip: '🗜️', rar: '🗜️', '7z': '🗜️',
      // Code
      js: '📜', jsx: '📜', ts: '📜', html: '📜', css: '📜', json: '📜'
    };

    return iconMap[extension] || '📁'; // Default icon
  };

  // Check if file is an image
  const isImageFile = (file) => {
    if (!file) return false;
    const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'];
    return imageTypes.includes(file.type);
  };

  const handleRemoveChip = (_, index) => {
    let keywordToUpdate = [...keyword];
    keywordToUpdate.splice(index, 1);
    setKeyword(keywordToUpdate);
  };

  const handleAddKeyword = (event) => {
    event.preventDefault();
    if (event.key === "Enter") {
      setKeyword([...keyword, event.target.value]);
      document.querySelector(".keyword").value = "";
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="modal-id"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close dismiss-dataset-modal"
                id="dismiss-dataset-modal"
                data-dismiss="modal"
                aria-hidden="Close"
                onClick={() => resetModalForm()}
              ></button>
              <button
                type="button"
                className="btn-close __close del-page-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetModalForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps">
                    Step 
                    <span className="__hidden2">1</span>
                    <span className="hidden1">2</span>
                    <span className="hidden2">3</span>
                    of 3
                  </p>
                  <p className="__modseps1">Dataset Details</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-7">
                  <div className="text-center __hidden2">
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden1">
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden2">
                    <span className="__kangprog"></span>
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form encType="multipart/form-data">
                    <div className="__hidden2">
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Dataset Name
                        </label>
                        <input
                          type="text"
                          className={`form-control __regdivform ${datasetNameError ? 'error-border' : ''}`}
                          placeholder="E.g. Child Care"
                          value={datasetName}
                          onChange={(event) =>
                            handleDatasetNameChange(event.target.value)
                          }
                        />
                        {datasetNameError && (
                          <div className="error-message text-danger small mt-1">
                            {datasetNameError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {datasetName.length} characters
                          {datasetName.length >= MIN_TITLE_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <label className="__modlab">Type</label>
                            <select
                              className="form-control __regdivform"
                              onChange={(event) =>
                                setDatasetType(event.target.value)
                              }
                            >
                              <option value="file">File</option>
                              <option value="link">Link</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Description 
                        </label>
                        <textarea
                          className={`form-control __regdivform ${descriptionError ? 'error-border' : ''}`}
                          rows="5"
                          value={descriptionValue}
                          onChange={(event) =>
                            handleDescriptionChange(event.target.value)
                          }
                          placeholder="Enter description (minimum 10 characters)"
                        ></textarea>
                        {descriptionError && (
                          <div className="error-message text-danger small mt-1">
                            {descriptionError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {descriptionValue.length} characters
                          {descriptionValue.length >= MIN_DESCRIPTION_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="__spacet7p"></div>
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                          <a className="btn btn-block __autbtn showButton show1">
                            Proceed
                          </a>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      </div>
                    </div>

                    <div className="hidden1">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className={`form-control __regdivform ${titleError ? 'error-border' : ''}`}
                              placeholder="Title"
                              value={title}
                              onChange={(event) => handleTitleChange(event.target.value)}
                            />
                            {titleError && (
                              <div className="error-message text-danger small mt-1">
                                {titleError}
                              </div>
                            )}
                            <div className="character-count text-muted small mt-1">
                              {title.length} characters
                              {title.length >= MIN_TITLE_LENGTH && (
                                <span className="text-success"> ✓</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="" className="__modlab">
                              Category
                            </label>
                            <select
                              className="form-control __regdivform"
                              onChange={(event) => {
                                setDatasetCategory(event.target.value);
                              }}
                            >
                              <option value="" selected disabled>
                                Please select a category
                              </option>
                              <option value="education">Education</option>
                              <option value="health">Health</option>
                              <option value="economic affairs">
                                Economic Affairs
                              </option>
                              {/* <option value="environment">Environment</option>
                              <option value="housing">Housing</option> */}
                              <option value="public order safety">Public Order & Safety</option>
                              <option value="general public service">General Public Service</option>
                              <option value="environmental protection">Environmental Protection</option>
                              <option value="housing and community amenities">Housing and community Amenities</option>
                              <option value="social protection">Social Protection</option>
                              <option value="recreation culture and religion">Recreation, Culture and Religion</option>
                            </select>
                          </div>
                        </div>

                        {datasetType === "link" && (
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control __regdivform"
                                placeholder="Embed Url"
                                value={file}
                                onChange={(event) =>
                                  setFile(event.target.value)
                                }
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="__spacet5p"></div>
                      <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a className="btn btn-block __autbtn1 hideButton">
                            Back
                          </a>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2"></div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a className="btn btn-block __autbtn showButton1 show2">
                            Continue
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="hidden2">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control __regdivform"
                          placeholder="Email"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                        />
                      </div>
                      <div
                        className="form-group"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          id="consent"
                          value={consent}
                          onChange={(event) => setConsent(event.target.checked)}
                          style={{ width: "15px", cursor: "pointer" }}
                          checked={consent === true}
                        />

                        <label
                          htmlFor="consent"
                          className="__modlab"
                          style={{
                            marginBottom: 0,
                            marginTop: "5px",
                            marginLeft: "10px",
                          }}
                        >
                          I confirm that all the information that I have
                          provided are genuine and valid.
                        </label>
                      </div>
                      <div className="__spacet5p"></div>
                      <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a className="btn btn-block __autbtn1 hideButton1 ">
                            Back
                          </a>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2"></div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a
                            className="btn btn-block __autbtn"
                            onClick={handleSubmitDataset}
                          >
                            Finish{" "}
                            {showLoader && (
                              <img src="/assets/img/loader.gif" alt="" />
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className=" __it">
                    <div className="uploadDoc">
                      <div className="fileUpload btn btn-orange">
                        {datasetType === "file" && file ? (
                          <div className="file-preview">
                            {isImageFile(file) ? (
                              <img src={URL.createObjectURL(file)} alt="Preview" className="image-preview" />
                            ) : (
                              <span className="file-icon">{getFileIcon(file)}</span>
                            )}
                            <span className="file-name">{file.name}</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            {datasetType === "file" ? (
                              <span className="__upl">Browse <span>file here</span></span>
                            ) : (
                              <span className="__upl">Select "file" as type to enable</span>
                            )}
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          onChange={(event) => setFile(event.target.files[0])}
                          disabled={datasetType !== "file"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-quesId"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close del-page-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetModalForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps">
                    Step
                    <span className="__hidden2">1</span>
                    <span className="hidden1">2</span>
                    of 2
                  </p>
                  <p className="__modseps1">Question Logic</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-7">
                  <div className="text-center __hidden2">
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden1">
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                  </div>

                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form encType="multipart/form-data">
                    <div className="__hidden2">
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Question
                        </label>
                        <input
                          type="text"
                          className={`form-control __regdivform ${questionError ? 'error-border' : ''}`}
                          placeholder="E.g. How many buses are owned by Lagos state Govt."
                          value={question}
                          onChange={(event) => handleQuestionChange(event.target.value)}
                        />
                        {questionError && (
                          <div className="error-message text-danger small mt-1">
                            {questionError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {question.length} characters
                          {question.length >= MIN_TITLE_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="" className="__modlab">
                              Type
                            </label>
                            <select
                              className="form-control __regdivform"
                              onChange={(event) => {
                                setQuestionType(event.target.value);
                                setAnalytics("");
                              }}
                            >
                              <option value="file">File</option>
                              <option value="iframe">Link</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Description
                        </label>
                        <textarea
                          className={`form-control __regdivform ${questionDescriptionError ? 'error-border' : ''}`}
                          rows="5"
                          value={questionDescription}
                          onChange={(event) =>
                            handleQuestionDescriptionChange(event.target.value)
                          }
                          placeholder="Enter description (minimum 10 characters)"
                        ></textarea>
                        {questionDescriptionError && (
                          <div className="error-message text-danger small mt-1">
                            {questionDescriptionError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {questionDescription.length} characters
                          {questionDescription.length >= MIN_DESCRIPTION_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="__spacet7p"></div>
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                          <a className="btn btn-block __autbtn showButton show1">
                            Proceed
                          </a>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      </div>
                    </div>

                    <div className="hidden1">
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control __regdivform"
                          placeholder="Findings"
                          rows="5"
                          value={questionFinding}
                          onChange={(event) =>
                            setQuestionFinding(event.target.value)
                          }
                        ></textarea>
                      </div>
                      {questionType === "iframe" && (
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control __regdivform"
                            placeholder="Iframe"
                            value={analytics}
                            onChange={(event) =>
                              setAnalytics(event.target.value)
                            }
                          />
                        </div>
                      )}
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Keywords
                        </label>
                        <div
                          style={{
                            minHeight: "50px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div>
                            {keyword.length
                              ? keyword.map((label, index) => (
                                  <Chip
                                    label={label}
                                    removeChip={(_) =>
                                      handleRemoveChip(_, index)
                                    }
                                    key={index}
                                  />
                                ))
                              : null}
                          </div>
                          <input
                            type="text"
                            className="form-control1 __regdivform1 keyword"
                            placeholder="Add keyword"
                            style={{
                              marginTop: "8px",
                              outline: "none",
                              width: "50%",
                              borderRight: "none",
                              borderTop: "none",
                              borderLeft: "none",
                              borderBottom: "1px solid #00000033",
                            }}
                            onKeyUp={handleAddKeyword}
                          />
                        </div>
                      </div>
                      <div className="__spacet5p"></div>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                          <a className="btn btn-block __autbtn1 hideButton">
                            Back
                          </a>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4"></div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                          <a
                            className="btn btn-block __autbtn"
                            onClick={handleSubmitQuestion}
                          >
                            Finish{" "}
                            {showQuestionLoader && (
                              <img src="/assets/img/loader.gif" alt="" />
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className=" __it">
                    <div className="uploadDoc">
                      <div className="fileUpload btn btn-orange">
                        {questionType === "file" && analytics instanceof File ? (
                          <div className="file-preview">
                            {isImageFile(analytics) ? (
                              <img src={URL.createObjectURL(analytics)} alt="Preview" className="image-preview" />
                            ) : (
                              <span className="file-icon">{getFileIcon(analytics)}</span>
                            )}
                            <span className="file-name">{analytics.name}</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            {questionType === "file" ? (
                              <span className="__upl">Browse <span>file here</span></span>
                            ) : (
                              <span className="__upl">Select "file" as type to enable</span>
                            )}
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          onChange={(event) => setAnalytics(event.target.files[0])}
                          disabled={questionType !== "file"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* DATASET ENDS HERE */}

      <div
        className="modal fade"
        id="modal-idpub"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close del-page-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetPublicationForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps1">Publications</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form>
                    <div className="form-group">
                      <label className="__modlab">Publication Title</label>
                      <input
                        type="text"
                        className={`form-control __regdivform ${publicationTitleError ? 'error-border' : ''}`}
                        placeholder="E.g. Child Care"
                        value={publicationTitle}
                        onChange={(event) =>
                          handlePublicationTitleChange(event.target.value)
                        }
                      />
                      {publicationTitleError && (
                        <div className="error-message text-danger small mt-1">
                          {publicationTitleError}
                        </div>
                      )}
                      <div className="character-count text-muted small mt-1">
                        {publicationTitle.length} characters
                        {publicationTitle.length >= MIN_TITLE_LENGTH && (
                          <span className="text-success"> ✓</span>
                        )}
                      </div>
                    </div>
                    <div className="row"></div>
                    <div className="form-group">
                      <label className="__modlab">Iframe</label>
                      <input
                        type="text"
                        className="form-control __regdivform"
                        placeholder="Optional"
                        value={publicationIframe}
                        onChange={(event) =>
                          setPublicationIframe(event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label className="__modlab">Description</label>
                      <textarea
                        className={`form-control __regdivform ${publicationBodyError ? 'error-border' : ''}`}
                        rows="5"
                        value={publicationBody}
                        onChange={(event) =>
                          handlePublicationBodyChange(event.target.value)
                        }
                        placeholder="Enter description (minimum 10 characters)"
                      ></textarea>
                      {publicationBodyError && (
                        <div className="error-message text-danger small mt-1">
                          {publicationBodyError}
                        </div>
                      )}
                      <div className="character-count text-muted small mt-1">
                        {publicationBody.length} characters
                        {publicationBody.length >= MIN_DESCRIPTION_LENGTH && (
                          <span className="text-success"> ✓</span>
                        )}
                      </div>
                    </div>
                    <div className="__spacet7p"></div>
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <a
                          className="btn btn-block __autbtn"
                          onClick={handleSubmitPublication}
                        >
                          Finish
                          {showPublicationLoader && (
                            <img src="/assets/img/loader.gif" alt="" />
                          )}
                        </a>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className=" __it" style={{ marginTop: "35px" }}>
                    <div className="uploadDoc" style={{ marginBottom: "20px" }}>
                      <div className="fileUpload btn btn-orangepub p-0">
                        {publicationBanner ? (
                          <div className="file-preview">
                            {publicationBanner.type.startsWith('image/') ? (
                              <img
                                src={URL.createObjectURL(publicationBanner)}
                                alt="Banner Preview"
                                className="image-preview"
                              />
                            ) : (
                              <span className="file-icon">{getFileIcon(publicationBanner)}</span>
                            )}
                            <span className="file-name">{publicationBanner.name}</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            <span className="__upl">
                              Upload <span>Banner</span>
                            </span>
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          required="required"
                          onChange={(event) => setPublicationBanner(event.target.files[0])}
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="uploadDoc">
                      <div className="fileUpload btn btn-orangepub p-0">
                        {publicationFile ? (
                          <div className="file-preview">
                            {publicationFile.type.startsWith('image/') ? (
                              <img
                                src={URL.createObjectURL(publicationFile)}
                                alt="File Preview"
                                className="image-preview"
                              />
                            ) : (
                              <span className="file-icon">{getFileIcon(publicationFile)}</span>
                            )}
                            <span className="file-name">{publicationFile.name}</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            <span className="__upl">
                              Upload <span>File</span>
                            </span>
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          required="required"
                          onChange={(event) => setPublicationFile(event.target.files[0])}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-team"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close del-page-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetTeamForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps1">Team</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form>
                    <div className="form-group">
                      <label className="__modlab">Member Name</label>
                      <input
                        type="text"
                        className={`form-control __regdivform ${teamNameError ? 'error-border' : ''}`}
                        value={teamName}
                        onChange={(event) => handleTeamNameChange(event.target.value)}
                      />
                      {teamNameError && (
                        <div className="error-message text-danger small mt-1">
                          {teamNameError}
                        </div>
                      )}
                      <div className="character-count text-muted small mt-1">
                        {teamName.length} characters
                        {teamName.length >= MIN_TITLE_LENGTH && (
                          <span className="text-success"> ✓</span>
                        )}
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="__modlab">Member role</label>
                      <input
                        type="text"
                        className="form-control __regdivform"
                        placeholder="e.g Personal Assistant"
                        value={teamPosition}
                        onChange={(event) =>
                          setTeamPosition(event.target.value)
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label className="__modlab">Member Office</label>
                      <input
                        type="text"
                        className="form-control __regdivform"
                        placeholder="e.g Ministry of Education"
                        value={teamOffice}
                        onChange={(event) =>
                          setTeamOffice(event.target.value)
                        }
                      />
                    </div>
                    <div className="__spacet7p"></div>
                    <div className="row">
                      <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
                      <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                        <button
                          className="btn btn-block __autbtn"
                          onClick={handleSubmitTeam}
                        >
                          Create Member
                          {showTeamLoader && (
                            <img src="/assets/img/loader.gif" alt="" />
                          )}
                        </button>
                      </div>
                      <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className="__it" style={{ marginTop: "35px" }}>
                    <div className="uploadDoc" style={{ marginBottom: "20px" }}>
                      <div className="fileUpload btn btn-orange p-0">
                        {teamImage ? (
                          <div className="file-preview">
                            <div className="image-preview-container">
                              {teamImage instanceof Blob ? (
                                <img
                                  src={URL.createObjectURL(teamImage)}
                                  alt="Team Preview"
                                  className="image-preview"
                                  onLoad={() => URL.revokeObjectURL(teamImage)}
                                  onError={(e) => {
                                    console.error("Image load error:", teamImage);
                                    e.target.src = 'https://via.placeholder.com/120x120?text=Image+Error';
                                  }}
                                />
                              ) : (
                                <div className="image-error">Invalid image file</div>
                              )}
                            </div>
                            <div className="file-info">
                              <span className="file-name">{teamImage.name}</span>
                              <span className="file-size">
                                {(teamImage.size / 1024).toFixed(1)} KB
                              </span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            <span className="__upl">
                              Upload <span>Image</span>
                            </span>
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          onChange={(event) => {
                            const file = event.target.files?.[0];
                            if (!file) return;

                            if (!file.type.startsWith('image/')) {
                              console.error("Invalid file type:", file.type);
                              toast.error('Please select an image file (JPEG, PNG, etc.)');
                              return;
                            }

                            const reader = new FileReader();
                            reader.onload = (e) => {
                              console.log("File read successfully");
                              setTeamImage(file);
                            };
                            reader.onerror = () => {
                              console.error("File reading error");
                              toast.error('Error reading image file');
                            };
                            reader.readAsDataURL(file);
                          }}
                          accept="image/*"
                          id="team-image-upload"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-idia"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetInteractiveAnalysisForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps"></p>
                  <p className="__modseps1">Interactive Analysis</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-7">
                  <div className="text-center hidden1">
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden2">
                    <span className="__kangprog"></span>
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form encType="multipart/form-data">
                    <div className="form-group">
                      <label htmlFor="" className="__modlab">
                        Title
                      </label>
                      <input
                        type="text"
                        className={`form-control __regdivform ${interactiveTitleError ? 'error-border' : ''}`}
                        placeholder="Interactive Analysis Title"
                        value={interactiveAnalysisTitle}
                        onChange={(event) =>
                          handleInteractiveTitleChange(event.target.value)
                        }
                      />
                      {interactiveTitleError && (
                        <div className="error-message text-danger small mt-1">
                          {interactiveTitleError}
                        </div>
                      )}
                      <div className="character-count text-muted small mt-1">
                        {interactiveAnalysisTitle.length} characters
                        {interactiveAnalysisTitle.length >= MIN_TITLE_LENGTH && (
                          <span className="text-success"> ✓</span>
                        )}
                      </div>
                    </div>
                    {interactiveAnalysisType === "iframe" && (
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          iFrame
                        </label>
                        <input
                          type="text"
                          className="form-control __regdivform"
                          placeholder="Interactive Analysis Title"
                          value={interactiveAnalysisFile}
                          onChange={(event) =>
                            setInteractiveAnalysisFile(event.target.value)
                          }
                        />
                      </div>
                    )}

                    <div className="form-group">
                      <label htmlFor="" className="__modlab">
                        Category
                      </label>
                      <select
                        className="form-control __regdivform"
                        onChange={(event) => {
                          setInteractivityCategory(event.target.value);
                        }}
                      >
                        <option value="" selected disabled>
                          Please select a category
                        </option>
                        <option value="education">Education</option>
                        <option value="health">Health</option>
                        <option value="economic affairs">
                          Economic Affairs
                        </option>
                        {/* <option value="environment">Environment</option>
                        <option value="housing">Housing</option> */}
                        <option value="public order safety">Public Order & Safety</option>
                        <option value="general public service">General Public Service</option>
                        <option value="environmental protection">Environmental Protection</option>
                        <option value="housing and community amenities">Housing and community Amenities</option>
                        <option value="social protection">Social Protection</option>
                        <option value="recreation culture and religion">Recreation, Culture and Religion</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="" className="__modlab">
                        Description
                      </label>
                      <textarea
                        className={`form-control __regdivform ${interactiveDescriptionError ? 'error-border' : ''}`}
                        rows="5"
                        value={interactiveAnalysisDescription}
                        onChange={(event) =>
                          handleInteractiveDescriptionChange(event.target.value)
                        }
                        placeholder="Enter description (minimum 10 characters)"
                      ></textarea>
                      {interactiveDescriptionError && (
                        <div className="error-message text-danger small mt-1">
                          {interactiveDescriptionError}
                        </div>
                      )}
                      <div className="character-count text-muted small mt-1">
                        {interactiveAnalysisDescription.length} characters
                        {interactiveAnalysisDescription.length >= MIN_DESCRIPTION_LENGTH && (
                          <span className="text-success"> ✓</span>
                        )}
                      </div>
                    </div>
                    <div className="__spacet20p"></div>
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <a
                          className="btn btn-block __autbtn"
                          onClick={handleSubmitInteractivity}
                        >
                          Finish{" "}
                          {showInteractiveAnalysisLoader && (
                            <img src="/assets/img/loader.gif" alt="" />
                          )}
                        </a>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className="__it">
                    <div className="uploadDoc">
                      <div className="fileUpload btn btn-orange">
                        {interactiveAnalysisType !== "iframe" && interactiveAnalysisFile?.length > 0 ? (
                         <div className="interactive-preview">
                          <div className="preview-header">
                            <span className="file-count">{interactiveAnalysisFile.length} file(s) selected</span>
                            <span className="file-types">
                              {[
                                ...new Set(
                                  Array.from(interactiveAnalysisFile).map(file => file.type.split('/')[0])
                                )
                              ].join(', ')}
                            </span>
                          </div>
                          <div className="preview-grid">
                            {Array.from(interactiveAnalysisFile).slice(0, 4).map((file, index) => (
                              <div key={index} className="preview-item">
                                {file.type.startsWith('image/') ? (
                                  <img 
                                    src={URL.createObjectURL(file)} 
                                    alt={`Preview ${index + 1}`} 
                                    className="thumbnail"
                                  />
                                ) : (
                                  <div className="file-type-icon">
                                    {file.type.startsWith('video/') ? '🎬' : getFileIcon(file)}
                                  </div>
                                )}
                                <span className="file-name">{file.name}</span>
                              </div>
                            ))}
                            {interactiveAnalysisFile.length > 4 && (
                              <div className="more-files">+{interactiveAnalysisFile.length - 4}</div>
                            )}
                          </div>
                        </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            {interactiveAnalysisType !== "iframe" ? (
                              <span className="__upl">
                                Browse <span>files here</span>
                              </span>
                            ) : (
                              <span className="__modlab">
                                Select Images or MP4 to enable
                              </span>
                            )}
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          required="required"
                          name="files"
                          multiple
                          accept={interactiveAnalysisType === 'video' ? 'video/*' : 
                                interactiveAnalysisType === 'image' ? 'image/*' : '*'}
                          onChange={(event) => setInteractiveAnalysisFile(event.target.files)}
                          disabled={interactiveAnalysisType === "iframe"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group __seleimgdiv">
                    <label htmlFor="" className="__modlab">
                      Select file to Upload
                    </label>
                    <select
                      className="form-control __regdivform"
                      onChange={(event) => {
                        setInteractiveAnalysisFile(undefined);
                        setInteractiveAnalysisType(event.target.value);
                      }}
                      value={interactiveAnalysisType}
                    >
                      <option value="video">MP4</option>
                      <option value="image">Image</option>
                      <option value="iframe">iFrame</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-section"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetModalForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-5">
                  <p className="__modseps">
                    Step
                    <span className="__hidden2">1</span>
                    <span className="hidden1">2</span>
                    of 2
                  </p>
                  <p className="__modseps1">CMS section</p>
                </div>
                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                  <div className="text-center __hidden2">
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden1">
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form encType="multipart/form-data">
                    <div className="__hidden2">
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Section Name
                        </label>
                        <input
                          type="text"
                          className={`form-control __regdivform ${sectionNameError ? 'error-border' : ''}`}
                          placeholder="statistics of private owned buses"
                          value={sectionName}
                          onChange={(event) =>
                            handleSectionNameChange(event.target.value)
                          }
                        />
                        {sectionNameError && (
                          <div className="error-message text-danger small mt-1">
                            {sectionNameError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {sectionName.length} characters
                          {sectionName.length >= MIN_TITLE_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Type
                        </label>
                        <select
                          className="form-control __regdivform"
                          onChange={(event) => {
                            setSectionType(event.target.value);
                            setSectionBody("");
                          }}
                        >
                          <option value="image">Image</option>
                          <option value="content">Content</option>
                          <option value="url">Url</option>
                        </select>
                      </div>

                      <div
                        className="__spacet7p"
                        style={{ marginTop: "27%" }}
                      ></div>
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                          <a className="btn btn-block __autbtn showButton show1">
                            Proceed
                          </a>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      </div>
                    </div>

                    <div className="hidden1">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="" className="__modlab">
                              Position
                            </label>
                            <select
                              className="form-control __regdivform"
                              onChange={(event) =>
                                setSectionPosition(event.target.value)
                              }
                            >
                              <option value="right">Right</option>
                              <option value="top">Top</option>
                              <option value="bottom">Bottom</option>
                              <option value="left">Left</option>
                              <option value="middle">Middle</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          {sectionType === "content" && (
                            <div className="form-group">
                              <label htmlFor="" className="__modlab">
                                Body
                              </label>
                              <textarea
                                className={`form-control __regdivform ${sectionBodyError ? 'error-border' : ''}`}
                                rows="5"
                                value={sectionBody}
                                onChange={(event) =>
                                  handleSectionBodyChange(event.target.value)
                                }
                                placeholder="Enter content (minimum 10 characters)"
                              ></textarea>
                              {sectionBodyError && (
                                <div className="error-message text-danger small mt-1">
                                  {sectionBodyError}
                                </div>
                              )}
                              <div className="character-count text-muted small mt-1">
                                {sectionBody.length} characters
                                {sectionBody.length >= MIN_DESCRIPTION_LENGTH && (
                                  <span className="text-success"> ✓</span>
                                )}
                              </div>
                            </div>
                          )}
                          {sectionType === "url" && (
                            <div className="form-group">
                              <label htmlFor="" className="__modlab">
                                Iframe
                              </label>
                              <input
                                type="text"
                                className="form-control __regdivform"
                                placeholder="https://www.power-bi...."
                                value={sectionBody}
                                onChange={(event) =>
                                  setSectionBody(event.target.value)
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="__spacet5p"></div>
                      <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a className="btn btn-block __autbtn1 hideButton">
                            Back
                          </a>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2"></div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a
                            className="btn btn-block __autbtn"
                            onClick={handleCreateSection}
                          >
                            Finish{" "}
                            {showSectionLoader && (
                              <img src="/assets/img/loader.gif" alt="" />
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                  <div className=" __it">
                    <div className="uploadDoc">
                      <div className="fileUpload btn btn-orange">
                        {sectionType === "image" && sectionBody instanceof File ? (
                          <div className="section-preview">
                            <div className="preview-container">
                              {sectionBody.type.startsWith('image/') ? (
                                <img
                                  src={URL.createObjectURL(sectionBody)}
                                  alt="Section Preview"
                                  className="preview-image"
                                  onLoad={() => URL.revokeObjectURL(sectionBody)}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'https://via.placeholder.com/150x100?text=Image+Error';
                                  }}
                                />
                              ) : (
                                <div className="invalid-file">
                                  <span className="file-icon">{getFileIcon(sectionBody)}</span>
                                  <span>Invalid image file</span>
                                </div>
                              )}
                            </div>
                            <div className="file-details">
                              <span className="file-name">{sectionBody.name}</span>
                              <span className="file-size">{(sectionBody.size / 1024).toFixed(1)} KB</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                              }}
                            />
                            <br />
                            {sectionType === "image" ? (
                              <span className="__upl">Browse <span>file here</span></span>
                            ) : (
                              <span className="__upl">Select type "image" to enable</span>
                            )}
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          required="required"
                          id="section-image-upload"
                          onChange={(event) => {
                            const file = event.target.files?.[0];
                            if (!file) return;

                            if (!file.type.startsWith('image/')) {
                              toast.error('Please select a valid image file (JPEG, PNG, etc.)');
                              return;
                            }

                            if (file.size > 5 * 1024 * 1024) {
                              toast.error('Image must be smaller than 5MB');
                              return;
                            }

                            setSectionBody(file);
                          }}
                          accept="image/*"
                          disabled={sectionType !== "image"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-page"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close page-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetModalForm()}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps">
                    Step
                    <span className="__hidden2">1</span>
                    <span className="hidden1">2</span>
                    <span className="hidden2">3</span>
                    of 3
                  </p>
                  <p className="__modseps1">CMS Page Details</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-7">
                  <div className="text-center __hidden2">
                    <span className="__kangproga"></span>
                    <span className="__kangprog"></span>
                  </div>

                  <div className="text-center hidden1">
                    <span className="__kangprog"></span>
                    <span className="__kangproga"></span>
                  </div>

                  <div className="text-center hidden2">
                    <span className="__kangprog"></span>
                    <span className="__kangprog"></span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-7 col-md-7 col-sm-7 __mobidown">
                  <form encType="multipart/form-data">
                    <div className="__hidden2">
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Title
                        </label>
                        <input
                          type="text"
                          className={`form-control __regdivform ${pageTitleError ? 'error-border' : ''}`}
                          placeholder="E.g. Child Care"
                          value={pageTitle}
                          onChange={(event) => handlePageTitleChange(event.target.value)}
                        />
                        {pageTitleError && (
                          <div className="error-message text-danger small mt-1">
                            {pageTitleError}
                          </div>
                        )}
                        <div className="character-count text-muted small mt-1">
                          {pageTitle.length} characters
                          {pageTitle.length >= MIN_TITLE_LENGTH && (
                            <span className="text-success"> ✓</span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Type
                        </label>
                        <select
                          className="form-control __regdivform"
                          onChange={(event) => setPageType(event.target.value)}
                        >
                          <option value="pages">Pages</option>
                          <option value="quick_reads">Quick Reads</option>
                          <option value="analysis">Analysis</option>
                          <option value="budgets">Budgets</option>
                          <option value="datasets">Datasets</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="" className="__modlab">
                          Body
                        </label>
                        <div className="form-group">
                          <CKEditor
                            editor={ClassicEditor}
                            data={pageBody}
                            onChange={(_, editor) =>
                              setPageBody(editor.getData())
                            }
                          />
                        </div>
                      </div>
                      <div className="__spacet7p"></div>
                      <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                          <a className="btn btn-block __autbtn showButton show1">
                            Proceed
                          </a>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3"></div>
                      </div>
                    </div>

                    <div className="hidden1">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="" className="__modlab">
                              Sections
                            </label>
                            <Select
                              isMulti
                              options={sectionOptions}
                              onChange={(value) => setPageSections(value)}
                            />
                          </div>
                          {pageType === "budgets" && (
                            <div className="form-group">
                              <label htmlFor="" className="__modlab">
                                Budget
                              </label>
                              <CKEditor
                                editor={ClassicEditor}
                                data={budgets}
                                onChange={(_, editor) =>
                                  setBudget(editor.getData())
                                }
                              />
                            </div>
                          )}
                          {pageType === "analysis" && (
                            <div className="form-group">
                              <label htmlFor="" className="__modlab">
                                iFrame
                              </label>
                              <input
                                type="text"
                                className="form-control __regdivform"
                                placeholder="http://www.powerbi..."
                                value={iFrame}
                                onChange={(event) =>
                                  setPageIframe(event.target.value)
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="__spacet5p"
                        style={{ marginTop: "39%" }}
                      ></div>
                      <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a className="btn btn-block __autbtn1 hideButton">
                            Back
                          </a>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-2"></div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-6">
                          <a
                            className="btn btn-block __autbtn"
                            onClick={handleCreatePage}
                          >
                            Finish{" "}
                            {showPageLoader && (
                              <img src="/assets/img/loader.gif" alt="" />
                            )}
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="col-lg-5 col-md-5 col-sm-5 __mobiup">
                <div className="__it" style={{ marginTop: pageType === "datasets" ? 35 : null }}>
                    {/* Banner Upload */}
                    <div 
                      className="uploadDoc" 
                      style={{ marginBottom: pageType === "datasets" ? 20 : null }}
                    >
                      <div className={`fileUpload btn btn-orange ${pageType === "datasets" ? "p-0" : ""}`}>
                        {pageBanner ? (
                          <div className="banner-preview">
                            <div className="preview-container">
                              {pageBanner.type.startsWith('image/') ? (
                                <img
                                  src={URL.createObjectURL(pageBanner)}
                                  alt="Banner Preview"
                                  className="preview-image"
                                  onLoad={() => URL.revokeObjectURL(pageBanner)}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'https://via.placeholder.com/300x150?text=Banner+Error';
                                  }}
                                />
                              ) : (
                                <div className="invalid-file">
                                  <span className="file-icon">{getFileIcon(pageBanner)}</span>
                                  <span>Invalid banner image</span>
                                </div>
                              )}
                            </div>
                            <div className="file-details">
                              <span className="file-name">{pageBanner.name}</span>
                              <span className="file-size">{(pageBanner.size / 1024).toFixed(1)} KB</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                              className="icon __difimg"
                              alt="Upload icon"
                            />
                            <br />
                            <span className="__upl">
                              Upload <span>Banner</span>
                            </span>
                          </>
                        )}
                        <input
                          type="file"
                          className="upload up"
                          required="required"
                          onChange={(event) => {
                            const file = event.target.files?.[0];
                            if (!file) return;

                            if (!file.type.startsWith('image/')) {
                              toast.error('Please select a valid image file for banner');
                              return;
                            }

                            const img = new Image();
                            img.onload = () => {
                              setPageBanner(file);
                            };
                            img.onerror = () => {
                              toast.error('Error loading image file');
                            };
                            img.src = URL.createObjectURL(file);
                          }}
                          accept="image/*"
                        />
                      </div>
                    </div>

                    {/* Dataset File Upload (only shown when pageType is "datasets") */}
                    {pageType === "datasets" && (
                      <div className="uploadDoc">
                        <div className="fileUpload btn btn-orange p-0">
                          {datasetFile ? (
                            <div className="file-preview">
                              <div className="preview-container">
                                {datasetFile.type.startsWith('image/') ? (
                                  <img
                                    src={URL.createObjectURL(datasetFile)}
                                    alt="Dataset Preview"
                                    className="preview-image"
                                    onLoad={() => URL.revokeObjectURL(datasetFile)}
                                  />
                                ) : (
                                  <div className="file-icon-container">
                                    <span className="file-icon-large">{getFileIcon(datasetFile)}</span>
                                    <span className="file-type">{datasetFile.type.split('/')[1] || 'file'}</span>
                                  </div>
                                )}
                              </div>
                              <div className="file-details">
                                <span className="file-name">{datasetFile.name}</span>
                                <span className="file-size">{(datasetFile.size / 1024).toFixed(1)} KB</span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                                className="icon __difimg"
                                alt="Upload icon"
                              />
                              <br />
                              <span className="__upl">
                                Upload <span>Dataset</span>
                              </span>
                            </>
                          )}
                          <input
                            type="file"
                            className="upload up"
                            required="required"
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (!file) return;

                              if (file.size > 10 * 1024 * 1024) {
                                toast.error('Dataset file must be smaller than 10MB');
                                return;
                              }

                              setDatasetFile(file);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modal-sliceAndDice"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog __modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close __close dismiss-sliceAndDice-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseSliceAndDice}
              >
                &times;
              </button>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-5">
                  <p className="__modseps1">Slice and Dice</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4"></div>
              </div>
              <div className="__spacet7p"></div>
              <div className="row __flexsmail">
                <div className="col-lg-12 col-md-12 col-sm-12 __mobiup">
                  <div style={{ width: "50%", margin: "0 auto" }}>
                    <div className=" __it">
                      <div className="uploadDoc">
                        <div className="fileUpload btn btn-orange">
                          {sliceAndDiceFile ? (
                            <div className="slice-dice-preview">
                              <div className="preview-content">
                                {sliceAndDiceFile.type.startsWith('image/') ? (
                                  <img
                                    src={URL.createObjectURL(sliceAndDiceFile)}
                                    alt="File Preview"
                                    className="preview-thumbnail"
                                    onLoad={() => URL.revokeObjectURL(sliceAndDiceFile)}
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = 'https://via.placeholder.com/100x100?text=Preview+Error';
                                    }}
                                  />
                                ) : (
                                  <div className="file-icon-container">
                                    <span className="file-icon">{getFileIcon(sliceAndDiceFile)}</span>
                                    <span className="file-type">
                                      {sliceAndDiceFile.name.split('.').pop().toUpperCase()}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="file-meta">
                                <span className="file-name">{sliceAndDiceFile.name}</span>
                                <span className="file-size">
                                  {(sliceAndDiceFile.size / 1024).toFixed(1)} KB
                                </span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/136/136549.png"
                                className="icon"
                                alt="Upload icon"
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/50x50?text=Upload';
                                }}
                              />
                              <br />
                              <span className="__upl">
                                Browse <span>file here</span>
                              </span>
                            </>
                          )}
                          <input
                            type="file"
                            className="upload up"
                            required="required"
                            id="slice-dice-upload"
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (!file) return;

                              // Validate file size (example: 5MB max)
                              if (file.size > 5 * 1024 * 1024) {
                                toast.error('File size must be less than 5MB');
                                return;
                              }

                              // Validate file type if needed
                              const validTypes = [
                                'application/vnd.ms-excel',
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                'text/csv',
                                'application/json',
                                'image/jpeg',
                                'image/png'
                              ];
                              
                              if (!validTypes.includes(file.type)) {
                                toast.error('Please upload a valid file type (CSV, Excel, JSON, or image)');
                                return;
                              }

                              setSliceAndDiceFile(file);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <form encType="multipart/form-data">
                      <div className="__spacet5p"></div>
                      <div
                        className="row"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div className="col-lg- col-md-6 col-sm-6 col-xs-6">
                          <a
                            className="btn btn-block __autbtn"
                            onClick={handleSubmitSliceAndDice}
                          >
                            Finish{" "}
                            {showSliceAndDiceLoader && (
                              <img src="/assets/img/loader.gif" alt="" />
                            )}
                          </a>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for error styling */}
      <style jsx>{`
        .error-border {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
        }
        .error-message {
          font-size: 0.875rem;
          font-weight: 500;
        }
        .character-count {
          font-size: 0.75rem;
        }
      `}</style>

      <ToastContainer closeOnClick pauseOnHover></ToastContainer>
    </>
  );
};

export default Upload;